import React from 'react';

function Title(props) {
  return (
    <div className="title-wrapper">
      <p className={`qbank-title${props.className ? ` ${props.className}` : ''}`}>{props.title}</p>
    </div>
  );
}

export default Title;



// WEBPACK FOOTER //
// ./src/components/Title.js